import $ from 'jquery'
window.$ = window.jQuery = $

import { load } from '@shopify/theme-sections'
import Cart from 'shopify-cart'

import '../sections/theme-header'
import '../sections/theme-footer'

import '../../styles/theme.scss'

import rteWrappers from '../modules/rteWrappers'

load([`theme-header`, `theme-footer`])

window.theme = window.theme || {}
window.Cart = Cart
window.moneyFormat = window.theme.moneyFormat

document.addEventListener(`DOMContentLoaded`, () => {
  rteWrappers()
})
